<form [formGroup]="awbInscanForm" (ngSubmit)="getAwbInfo()">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">AWB Scan</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
            <div class="row">
                <div class="col-12">
                    <div class="mb-2">
                        <label>Please enter below <b>master</b> OR <b>child</b> shipment number to receive it in the system.</label>
                        <label for="" class="form-label"></label>
                        <input type="text" class="form-control form-control-sm"
                            formControlName="txtAwbNumber" placeholder="For e.g. 10000001"
                            [ngClass]="{'is-invalid': (isFormSubmitted || awbInscanForm.get('txtAwbNumber')?.touched) && awbInscanForm.get('txtAwbNumber').errors}">
                        <div *ngIf="(isFormSubmitted || awbInscanForm.get('txtAwbNumber')?.touched) && awbInscanForm.get('txtAwbNumber').errors"
                            class="invalid-feedback">
                            <span *ngIf="awbInscanForm.get('txtAwbNumber').errors.required">AWB Number is required.</span>
                        </div>
                    </div>
                
                    <!-- Display badges -->
                    <div *ngIf="shipmentList.length">
                        <span *ngFor="let shipment of shipmentList" class="badge bg-primary me-1">{{shipment}}</span>
                    </div>
    
                    <div class="row" *ngIf="rowData.length">
                        <div class="col-md-12 grid-container">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                                [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                                [defaultColDef]="defaultColDef" [suppressMenuHide]="true" [pagination]="true" [enableCellTextSelection]="true"
                                (gridReady)="onGridReady($event)"
                                [gridOptions]="gridOptions" [isRowSelectable]="isRowSelectable"> 
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        
        <div class="modal-footer">
            
        <button *ngIf="!allScan" type="submit" class="btn btn-outline-dark">Scan</button>
    
        <button *ngIf="partScan" type="button" class="btn btn-outline-dark" (click)="partialScan()">Scan Selected</button>
    </div>
    </form>